import { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MMBNavbar from "./navbar.js";
import CombinedLiveView from "./combined-live-view.js";
import CombinedHistoryView from "./combined-history-view.js";
import Login from "./login.js";
import { login } from "./utils.js";
import { connectSSE, disconnectSSE, getSSEStatus } from "./sse.js";

export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isTokenExpired, setIsTokenExpired] = useState(false);

  useEffect(() => {
    if (isLoggedIn && getSSEStatus()) {
      connectSSE();
      return () => {
        disconnectSSE();
      };
    }
  }, [isLoggedIn]);

  if (!isLoggedIn) {
    if (!isTokenExpired) {
      login().then((isValid) => {
        if (isValid) {
          setIsLoggedIn(true);
        } else {
          setIsTokenExpired(true);
        }
      });
      return <div />;
    }
    return <Login setIsLoggedIn={setIsLoggedIn} />;
  }

  return (
    <BrowserRouter>
      <MMBNavbar />
      <Routes>
        <Route path="/" element={<CombinedLiveView />} />
        <Route path="/history" element={<CombinedHistoryView />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
